/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Downloads_Compatibility_DesktopInputs */

const en_downloads_compatibility_desktop = /** @type {(inputs: Downloads_Compatibility_DesktopInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Supports macOS 12 Monterey or later and Windows 10 or later.`)
};

const es_downloads_compatibility_desktop = /** @type {(inputs: Downloads_Compatibility_DesktopInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Compatible con macOS 12 Monterey o posterior y Windows 10 o posterior.`)
};

/**
* | output |
* | --- |
* | "Supports macOS 12 Monterey or later and Windows 10 or later." |
*
* @param {Downloads_Compatibility_DesktopInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const downloads_compatibility_desktop = /** @type {((inputs?: Downloads_Compatibility_DesktopInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Downloads_Compatibility_DesktopInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_downloads_compatibility_desktop(inputs)
	return en_downloads_compatibility_desktop(inputs)
});